<template>
	<div>
		<div class="modal" :class="{'is-active': openModal}">
			<div class="modal-background"></div>
			<div class="modal-content">
				<slot></slot>
			</div>
			<button @click="closeModal" class="modal-close is-large" aria-label="close"></button>
		</div>

		<slot name="modal-button" v-bind="{ showModal }">
			<div class="field is-grouped">
				<div class="control">
					<base-button @click="showModal">{{ openButtonText }}</base-button>
				</div>
			</div>
		</slot>
	</div>
</template>

<script>
/** @format */

export default {
	props: {
		openButtonText: {
			type: String,
			default: 'Create New'
		}
	},
	methods: {
		closeModal() {
			this.openModal = false;
		},
		showModal() {
			this.openModal = true;
		}
	},
	data() {
		return {
			openModal: false
		};
	}
};
</script>
